import { FCX } from "@datassential/platform-ui-lib";
import BreadCrumbs, { BreadCrumbsItem } from "@components/BreadCrumbs/BreadCrumbs";
import './Profile.scss';
import ProfileHeader from "@pages/Profile/components/Header/Header";
import ContentWrapper from "@components/ContentWrapper/ContentWrapper";
import Experience from "@pages/Profile/components/Experience/Experience";
import Affinity from "@pages/Profile/components/Affinity/Affinity";
import Trend from "@pages/Profile/components/Trend/Trend";
import { useProfileData } from "@core/api/useProfileHeader";
import useQueryState from "@hooks/useQueryState";
import { useCategories, useCommonDataContext } from "@core/CommonDataContext";
import { useMemo } from "react";
import ConsumerGroups from "@pages/Profile/components/ConsumerGroups";
import OtherFlavors from "@pages/Profile/components/OtherItems";
import ProfileContextProvider from "@pages/Profile/ProfileContext";
import ProfileSubHeader from "@pages/Profile/components/SubHeader/SubHeader";
import { SelectAmongContextProvider } from "@vms/SelectAmong/SelectAmongContext";
import Loader from "@components/Loader";
import { Routes } from "@core/routes";

const ProfileComponent: FCX = () => {
    const [paramId] = useQueryState('keywordId');
    const id = useMemo(() => +paramId, [paramId])
    const { data, isLoading } = useProfileData(id);

    const {
        categoriesIds,
        primaryCategoryId,
    } = data ?? {};

    const [category] = useCategories([primaryCategoryId ?? (categoriesIds ?? [])[0]]);

    const breadCrumbsItems = useMemo(
        (): BreadCrumbsItem[] => {
            const items: BreadCrumbsItem[] = [
                {
                    id: "home",
                    name: "Home",
                    path: Routes.Home,
                    testId: "linkProfileBreadCrumbsHome",
                },
            ];

            if (category) {
                items.push({
                    id: "category",
                    name: category.name ?? '',
                    path: `${Routes.Home}?categoryId=${category.id}`,
                    className: 'js-breadcrumbs-link',
                    testId: "linkProfileBreadCrumbsCategory",
                });
            }

            items.push({
                id: "profile",
                name: data?.name ?? '',
                testId: "textProfileBreadCrumbsName",
            });

            return items;
        },
        [category, data?.name]
    );

    if (isLoading || data === null) {
        return <Loader/>;
    }

    return (
        <>
            <ContentWrapper>
                <div className="Profile">
                    <BreadCrumbs items={breadCrumbsItems}/>
                    <ProfileHeader
                        data={data}
                        testId="blockProfileHeader"
                    />
                    <ProfileSubHeader
                        categoriesIds={categoriesIds}
                        name={data.name}
                    />
                    <div className="Profile__section">
                        <Experience
                            id={id}
                            testId="blockProfileExperience"
                        />
                        <Affinity
                            id={id}
                            name={data.name}
                            testId="blockProfileAffinity"
                        />
                    </div>
                    <Trend
                        id={id}
                        name={data.name}
                        heatScore={data.heatScore}
                        testId="blockProfileTrend"
                    />
                    <ConsumerGroups
                        id={id}
                        testId="blockProfileConsumerGroups"
                    />
                    <OtherFlavors
                        id={id}
                        testId="blockProfileOtherItems"
                    />
                </div>
            </ContentWrapper>
        </>
    )
        ;
};

const Profile = () => {
    const { isLoading } = useCommonDataContext();

    if (isLoading) {
        return <Loader/>;
    }

    return (
        <ProfileContextProvider>
            <SelectAmongContextProvider>
                <ProfileComponent/>
            </SelectAmongContextProvider>
        </ProfileContextProvider>
    );
}

export default Profile;